import React from 'react';
import { Alert } from '@one-thd/sui-atomic-components';
import { InfoPerksContext, PerkProgressProvider } from '../../contexts';
import { pkPerkProgress } from '../../constants/ProXtraPerks';
import { useIsMobile } from '../../hooks';
import { AvailablePerks, PerkHistory, PerkProgress, ProXtraPerkBanner, PLCCBanner, } from '../../components/PerksPage';
import '../../styles/ProXtraPricing.scss';
export var PerksPageContainer = function () {
    var isMobile = useIsMobile().isMobile;
    var _a = React.useContext(InfoPerksContext), isLoading = _a.isLoading, perksInfo = _a.perksInfo, isPacDrawersEnabled = _a.isPacDrawersEnabled;
    var showPLCC = (perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.pxccUserCategory) === 'Enrolled' ||
        (perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.pxccUserCategory) === 'Targeted';
    if (perksInfo) {
        sessionStorage.setItem('perkCounter', JSON.stringify(perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.perkCounter));
        sessionStorage.setItem('perkRecentlyAdded', JSON.stringify(perksInfo === null || perksInfo === void 0 ? void 0 : perksInfo.recentlyAdded));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: isMobile ? 'col__12-12' : '', style: {
                visibility: isLoading ? 'hidden' : 'unset',
            } },
            React.createElement(ProXtraPerkBanner, { isMobile: isMobile }),
            isPacDrawersEnabled ? (React.createElement("div", { className: "sui-mb-2" },
                React.createElement(Alert, { status: "info" },
                    "Find your progress to your next Perk, make your Perk selections, and access all of your currently available Perks listed on the",
                    ' ',
                    React.createElement("a", { className: "sui-underline", rel: "noreferrer", href: pkPerkProgress.rewardsHubURL }, "Rewards Hub screen.")))) : (React.createElement(React.Fragment, null,
                showPLCC && React.createElement(PLCCBanner, { isMobile: isMobile }),
                React.createElement(PerkProgressProvider, { perksInfo: perksInfo },
                    React.createElement(PerkProgress, null),
                    React.createElement(AvailablePerks, { isMobile: isMobile })))),
            React.createElement(PerkHistory, { isMobile: isMobile }))));
};
